<form [formGroup]="pinForm">
  <div formArrayName="pin">
    <div class="pin-input-container">
      @for (digit of pinDigits; track digit; let i = $index) {
        <input
          (input)="onInputChange(i, $event)"
          (keydown.backspace)="onRemove(i)"
          (paste)="onPaste($event, i)"
          [id]="'pinInput' + i"
          formControlName="{{ i }}"
          inputmode="numeric"
          maxlength="1"
          pattern="[0-9]"
        />
      }
    </div>
  </div>
</form>
